<template>
  <li class="card relative nav-card p-[.75rem] flex flex-col items-start gap-1" role="none">
    <a
      :href="composeLink(navItemData.url)"
      class="cover-link slide font-heading font-bold text-lg nav__menu-item"
      tabindex="-1"
      role="menuitem"
      :qaid="`${navItemData.uid}-card`"
      @keydown.prevent.right="rightFunction"
      @keydown.prevent.left="leftFunction"
      @keydown.prevent.down="downFunction"
      @keydown.prevent.up="upFunction"
    >
      <span id="navItemData.uid" v-html="navItemData.linkName"></span>
    </a>
    <div class="nav-bike-grid-wrapper grid w-full gap-[.75rem] py-25 items-start" :class="gridClasses">
      <picture class="aspect-[5/3] pr-2 w-full block relative">
        <img :data-nav-image="imageAsset" class="object-contain h-full w-full absolute" loading="lazy" :alt="altText" />
      </picture>

      <ul class="flex flex-col">
        <li
          v-for="icon in navItemData.icons"
          :key="icon.specIcon"
          class="text-xs py-25 font-medium grid grid-cols-[18px_auto] gap-1 items-center"
        >
          <pdl-icon size="18" :name="getIconName(icon.specIcon)" />
          <span class="leading-none" v-html="icon.body" />
        </li>
      </ul>
    </div>
    <a
      v-for="secondaryLink in secondaryLinks"
      :key="secondaryLink.uid"
      :href="secondaryLink.url"
      role="menuitem"
      tabindex="-1"
      class="bg-blue-10 rounded-lg mt-auto hover:bg-blue-20 transition-colors transition-200 motion-reduce:transition-none text-xs text-blue-140 py-1 inline-block px-[1.25rem] relative z-20 nav__menu-item"
      :aria-labelledby="navItemData.uid"
      @keydown.prevent.right="rightFunction"
      @keydown.prevent.left="leftFunction"
      @keydown.prevent.down="downFunction"
      @keydown.prevent.up="upFunction"
    >
      {{ secondaryLink.linkName }}
    </a>
  </li>
</template>
<script>
import {Cloudinary, CloudinaryConstants} from '@/utils/image/cloudinary-helpers';
import {PdlIcon} from '@pedal/pdl-icon';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavBikeCard',
  components: {
    PdlIcon,
  },
  mixins: [links],
  inject: ['isElectra'],
  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
    rightFunction: {
      type: Function,
      default: () => {},
    },
    leftFunction: {
      type: Function,
      default: () => {},
    },
    upFunction: {
      type: Function,
      default: () => {},
    },
    downFunction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    imageAsset() {
      const imageTransforms = {
        q: 'auto',
        w: 260,
        dpr: `${window.devicePixelRatio}`,
        ...CloudinaryConstants.DEFAULT_PARAMETERS,
      };
      return this.navItemData.linkAssetID
        ? Cloudinary.createAssetUrl(this.navItemData.linkAssetID, imageTransforms)
        : '';
    },
    altText() {
      return this.navItemData.linkName;
    },
    secondaryLinks() {
      // "Generations", for now...
      return this.navItemData.secondaryLinks?.filter((link) => link.visible !== false) || [];
    },
    gridClasses() {
      return this.isElectra ? 'grid-cols-[1.6fr,_1fr]' : 'grid-cols-[2fr,_1fr]';
    },
  },
  methods: {
    getIconName(icon) {
      const name = icon.replace('icon', '');
      return name;
    },
  },
};
</script>
<style lang="scss" scoped>
.cover-link {
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 10;
    box-shadow: 0 4px 6px -2px rgb(0 0 0 / 0), 0 10px 15px -3px rgb(0 0 0 / 0);
    transition: box-shadow var(--nav-reduced-motion, 0.24s) ease;
  }

  @media (hover: hover) {
    &:hover {
      &::after {
        box-shadow: 0 4px 6px -2px rgb(0 0 0 /0.05), 0 10px 15px -3px rgb(0 0 0 /0.1);
      }

      &.slide ~ .nav-bike-grid-wrapper img {
        translate: 0.75rem;
      }
    }
  }
}

.slide ~ .nav-bike-grid-wrapper img {
  transition: translate var(--nav-reduced-motion, 0.185s) cubic-bezier(0.5, 0, 0.25, 1);
}
</style>
